import { Box, Button, Menu, MenuItem, styled } from "@mui/material";
import { useLocaleState } from "ra-core";
import * as React from "react";
import { MouseEvent, useState } from "react";
export const Division = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [division2, setDivision2] = useLocaleState();
  const division = localStorage.getItem("division") || "Personal";

  React.useEffect(() => {
    setDivision2(division);
    if (division2 != division) {
      setDivision2(division);
    }
  }, [division]);

  const changeDivision = (division: string) => (): void => {
    setAnchorEl(null);
    localStorage.setItem("division", division);
    setDivision2(division);
    console.log("Division changed to", division);
  };

  const handleLanguageClick = (event: MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
    localStorage.setItem("division", "Personal");
    setDivision2("Personal");
  };

  return (
    <Root component="span">
      <Button
        id="btn-switch-division"
        color="inherit"
        variant="outlined"
        aria-controls="simple-menu"
        aria-label=""
        aria-haspopup="true"
        onClick={handleLanguageClick}
        sx={{
          textTransform: "none",
          fontFamily: "Proxima Nova",
          border: "1px solid #1976d2",
          backgroundColor: "rgba(25, 118, 210, 0.2)",
          fontSize: "14px",
          width: "160px",
        }}
      >
        {division == "Business" ? "Business Products" : "Consumer Products"}
      </Button>
      <Menu
        id="division-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          key="Business"
          disabled
          selected={division == "Business"}
          sx={{
            textTransform: "none",
            fontFamily: "Proxima Nova",
            fontSize: "0.875rem",
          }}
        >
          Business Products
        </MenuItem>
        <MenuItem
          key="Personal"
          onClick={changeDivision("Personal")}
          selected={division != "Business"}
          sx={{
            textTransform: "none",
            fontFamily: "Proxima Nova",
            fontSize: "0.875rem",
          }}
        >
          Consumer Products
        </MenuItem>
      </Menu>
    </Root>
  );
};

const Root = styled(Box, {
  name: "RaDivision",
  overridesResolver: (props, styles) => styles.root,
})({});
